
import './index.less';
import { Modal, Table, Tooltip } from "antd";
import classnames from "classnames";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { ReactComponent as PlaceSvg } from '@/commons/icons/table/place.svg';
import { ReactComponent as CheckSvg } from '@/commons/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/commons/icons/table/checked.svg';
import { graphicStore } from "@/commons/store/graphic-store";
import { DEVICEBASE_SINGAL } from "@/passets/devicebase-engine/enums/devicebase-singal";
import { Vector3 } from "three";
import { Point } from "pytha";
import { DEVICE_SUB_CONTROL } from "@/passets/devicebase-engine/enums/device-sub-controls";
import { SerialT } from "@/passets/devicebase-engine/models/SerialT";
import { CommonTabbarContext, SideContext } from "@/App";
import { DATA_BOX_COMPONENT_TYPE, DATA_BOX_TYPE, getDataBoxTypeName } from "@/commons/enums/data-box-type";
import { DvrT } from "@/passets/devicebase-engine/models/DvrT";
import LinkGlobalDataBoxModal from "./link-modal";
import { createProjectGDataBoxes, deleteProjectGDataBox, getProjectDataBoxes } from "@/api/maint/project-device/project-data-box";
import { RsProjectGlobalDataBox } from "@/commons/interface/project-device/project-data-box";
import { GlobalDataBox } from "@/commons/interface/lib-device/global-data-box";
import axios from "axios";
import { getSpecialPrimitiveLayerUuid } from "@/commons/utils/layer-utils";
import { LayerType } from "@/commons/enums/layer-type";
import { findComponentByType } from "@/api/building/conponent";
import { Component } from "@/commons/interface/building/component";
import { SideStatus } from '@/commons/context/side-store';
import TnMessage from '@/commons/widget/message';
import TnModal from '@/commons/widget/base-modal';
import SideBarTool from '@/commons/components/side-bar-tool';
import { SideBarBtnType } from '@/commons/enums/side-bar-btn-type';
import { TAB_TYPE } from '@/commons/enums/tab-type';
import { DRAW_MAIN_KEY } from '@/routes/tab-routes';
import { CommonTabbarState } from '@/commons/components/common-tabbar';

interface IProps {
    dataBoxType: number
}

export default function DataBoxPanel(props: IProps) {
    const { projectUuid, modelUuid } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const sideContext = useContext<SideStatus>(SideContext);
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [activeRow, setActiveRow] = useState<GlobalDataBox>(null); // 表格选中行
    const [hoverRow, setHoverRow] = useState<GlobalDataBox>(null); // 鼠标悬浮行
    const [dataBoxes, setDataBoxes] = useState<GlobalDataBox[]>([]); // 采集箱列表
    const [showAddModal, setShowAddModal] = useState<boolean>(false); // 打开添加弹窗
    const [addLoading, setAddLoading] = useState<boolean>(false); // 添加弹窗的loading
    // const [showEditModal, setShowEditModal] = useState<boolean>(false); // 打开编辑弹窗
    // const [editLoading, setEditLoading] = useState<boolean>(false); // 编辑弹窗的loading
    const [muitiple, setMuitiple] = useState<boolean>(false); // 是否开启多选
    const [selectedRows, setSelectedRows] = useState<GlobalDataBox[]>([]); // 多选选中的列
    const [placeRow, setPlaceRow] = useState<GlobalDataBox>(); // 正在布置的采集箱
    // const dataBoxesRef = useRef(null); // 采集箱列表ref
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文

    // useEffect(() => {
    //     dataBoxesRef.current = dataBoxes;
    // }, [dataBoxes])

    // 监听二级控制器结束和按下ESC
    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        // graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDeviceFinish).add(onAssembleDeviceFinish);
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onOpeCommandControlEnd.add(onOpeCommandControlEnd);
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onProcessEscape.add(onOpeCommandControlEnd);

        return () => {
            if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
            // graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDeviceFinish).remove(onAssembleDeviceFinish);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onOpeCommandControlEnd.remove(onOpeCommandControlEnd);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onProcessEscape.remove(onOpeCommandControlEnd);
        }
    }, [graphicStore?.extraContext?.getCurrentViewEditor()])

    // 初始化
    useEffect(() => {
        if (!projectUuid) return;
        generateData();
    }, [projectUuid, sideContext.needRenderDataBoxSide])

    // 获取采集箱列表
    const generateData = () => {
        setLoading(true);
        getProjectDataBoxes(projectUuid, props.dataBoxType).then(res => {
            let data: GlobalDataBox[] = res.data || [];
            data = data?.filter(item => item.type === props.dataBoxType) || [];
            setDataBoxes(data);
        }).catch(err => {
            TnMessage.error("查询失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    // // 接收完成设备布置的回调信号
    // const onAssembleDeviceFinish = (e) => {
    //     let addPris = e.addPris;
    //     graphicStore.extraContext.getCurrentViewEditor().history.execute(new AddPrimitivesCommand(
    //         addPris,
    //         () => executeCallback(addPris),
    //         () => undoCallback(addPris)
    //     ))
    // }

    // // command的执行回调
    // const executeCallback = (addPris: ModelBase[]) => {
    //     createPrimitiveMulti(addPris?.map((entity: ModelBase) => {
    //         if (entity.toJson) {
    //             return entity.toJson();
    //         }
    //         return null
    //     })).then(() => {
    //         // 修改布置的采集箱信息
    //         let templateId = addPris[0].extraData?.globalDataBoxId || null;
    //         if (!templateId) return;
    //         let primitiveUuid = addPris[0].uuid;
    //         let par: DataBox = {
    //             primitiveUuid: primitiveUuid,
    //             templateId: templateId,
    //             projectUuid: projectUuid,
    //         }
    //         createDataBox(par).then(res => {
    //             if (res.status === 200) {
    //                 TnMessage.success("布置成功");
    //             }
    //         }).catch(err => {
    //             TnMessage.error("布置失败");
    //         })
    //     })
    // }

    // // command的撤回回调
    // const undoCallback = (addPris: ModelBase[]) => {
    //     deletePrimitivesInGraphic(addPris?.map(entity => entity.uuid)).then(res => {
    //         deleteDataBoxByPrimitiveUuid(addPris[0].uuid).then(res => {
    //             if (res.status === 200) {
    //                 TnMessage.success("取消布置成功");
    //             }
    //         }).catch(err => {
    //             TnMessage.error("解绑失败");
    //         })
    //     });
    // }

    // 二级控制器执行完成的回调
    const onOpeCommandControlEnd = () => {
        setPlaceRow(null);
    }


    // 监听多选的变化
    useEffect(() => {
        if (!muitiple) {
            setSelectedRows([]);
        }
    }, [muitiple])

    // 点击工具栏添加按钮
    const onAddClick = () => {
        setShowAddModal(true);
    }

    // 点击工具栏编辑按钮
    // const onEditClick = () => {
    //     if (!activeRow) {
    //         TnMessage.warning("未选中采集箱");
    //         return;
    //     }
    //     setShowEditModal(true);
    // }

    // 点击工具栏删除按钮
    const onDeleteClick = () => {
        if ((muitiple && selectedRows?.length === 0) || (!muitiple && !activeRow)) {
            TnMessage.warning("未选中采集箱");
            return;
        }

        TnModal().deleteModal({
            onOk() {
                if (!muitiple) {
                    deleteProjectGDataBox(projectUuid, activeRow?.id).then(res => {
                        if (res.status === 200) {
                            let idx = dataBoxes?.findIndex(item => item.id === activeRow.id);
                            dataBoxes.splice(idx, 1);
                            setDataBoxes([...dataBoxes]);
                            setActiveRow(null);
                            TnMessage.success("删除成功");
                        }
                    }).catch(err => {
                        TnMessage.error("删除失败");
                    }).finally(() => {
                        Modal.destroyAll();
                    })
                } else {
                    let promiseList = [];
                    for (let item of selectedRows) {
                        promiseList.push(() => deleteProjectGDataBox(projectUuid, item.id));
                    }
                    axios.all(promiseList?.map(fn => fn())).then(res => {
                        let newDataBoxs = dataBoxes?.filter(item => !selectedRows?.some(r => r.id === item.id));
                        setDataBoxes(newDataBoxs);
                        setSelectedRows([]);
                        TnMessage.success("删除成功");
                    }).catch(err => {
                        TnMessage.error("删除失败");
                    }).finally(() => {
                        Modal.destroyAll();
                    })
                }
            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true
        })

    }

    // 添加采集箱点击确认
    const onAddFinish = (values: number[]) => {
        if (values?.length === 0) {
            setShowAddModal(false);
            return;
        }
        let pars: RsProjectGlobalDataBox[] = values?.map(item => {
            let par: RsProjectGlobalDataBox = {
                projectUuid: projectUuid,
                globalDataBoxId: item,
            }
            return par;
        })
        setAddLoading(true);
        createProjectGDataBoxes(pars).then(res => {
            if (res.status === 200) {
                let newPDataBoxes = res.data || [];
                setDataBoxes([...dataBoxes, ...newPDataBoxes]);
                TnMessage.success("添加成功");
                setShowAddModal(false);
            }
        }).catch(err => {
            TnMessage.error(err?.data || "添加失败");
        }).finally(() => {
            setAddLoading(false);
        })
        // if (values?.copyNum === 0) {
        //     let par = {
        //         ...values,
        //         projectUuid: projectUuid,
        //     }
        //     setAddLoading(true);
        //     createDataBox(par).then(res => {
        //         if (res.status === 200) {
        //             let id = res.data;
        //             par = {
        //                 ...par,
        //                 id: id,
        //             }
        //             dataBoxes?.push(par);
        //             setDataBoxes([...dataBoxes]);
        //             TnMessage.success("添加成功");
        //             setShowAddModal(false);
        //         }
        //     }).catch(err => {
        //         TnMessage.error(err?.data || "添加失败");
        //     }).finally(() => {
        //         setAddLoading(false);
        //     })
        // } else {
        //     let dataList: DataBox[] = [];
        //     for (let i = 0; i <= values?.copyNum; i++) {
        //         let par = {
        //             ...values,
        //             projectUuid: projectUuid,
        //         }
        //         dataList.push(par);
        //     }
        //     setAddLoading(true);
        //     createDataBoxes(dataList).then(res => {
        //         if (res.status === 200) {
        //             let newDataBoxs = res.data || [];
        //             setDataBoxes([...dataBoxes, ...newDataBoxs]);
        //             TnMessage.success("添加成功");
        //             setShowAddModal(false);
        //         }
        //     }).catch(err => {
        //         TnMessage.error(err?.data || "添加失败");
        //     }).finally(() => {
        //         setAddLoading(false);
        //     })
        // }
    }

    // 编辑采集箱点击确认
    // const onEditFinish = (values) => {
    //     let par = {
    //         ...values,
    //         id: activeRow?.id,
    //     }
    //     setEditLoading(true);
    //     updateDataBox(activeRow.id, par).then(res => {
    //         if (res.status === 200) {
    //             let idx = dataBoxes?.findIndex(item => item.id === activeRow.id);
    //             dataBoxes[idx] = {
    //                 ...activeRow,
    //                 ...values,
    //             }
    //             setDataBoxes([...dataBoxes]);
    //             setActiveRow(pre => ({
    //                 ...pre,
    //                 ...values,
    //             }));
    //             TnMessage.success("编辑成功");
    //             setShowEditModal(false);
    //         }
    //     }).catch(err => {
    //         TnMessage.error(err?.data || "编辑失败");
    //     }).finally(() => {
    //         setEditLoading(false);
    //     })
    // }

    // 点击布置按钮
    const onPlaceClick = (row: GlobalDataBox) => {
        if (!row) return;
        if (!location.pathname.includes('draw/draw-main')) {
            commonTabbarContext.navigate(`${TAB_TYPE.DRAW}/${DRAW_MAIN_KEY}`);
            TnMessage.info("正在切换至绘图区...", { duration: 1 });
            return;
        }
        setPlaceRow(row);
        let layerType;
        if (props.dataBoxType === DATA_BOX_TYPE.DVR) {
            layerType = LayerType.DVR;
        } else if (props.dataBoxType === DATA_BOX_TYPE.SERIAL) {
            layerType = LayerType.SERIAL;
        }

        findComponentByType(DATA_BOX_COMPONENT_TYPE[props.dataBoxType]).then(res => {
            let data: Component = res.data;
            let block;
            if (props.dataBoxType === DATA_BOX_TYPE.SERIAL) {
                let component = new SerialT().fromJson(data);
                block = new SerialT(new Point(component?.position?.x, component?.position?.y, component?.position?.z), [component]);
            } else {
                let component = new DvrT().fromJson(data);
                block = new DvrT(new Point(component?.position?.x, component?.position?.y, component?.position?.z), [component]);
            }
            block.isColorByLayer = false;
            block.extraData = {
                globalDataBoxId: row?.id,
            }

            getSpecialPrimitiveLayerUuid(projectUuid, modelUuid, layerType).then((layerUuid: string) => {
                graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(DEVICE_SUB_CONTROL.ASSEMBLEDEVICE.name);
                block.layerUuid = layerUuid;
                graphicStore.extraContext.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDevice)
                    .dispatch(block, new Vector3(block?.position?.x, block?.position?.y, block?.position?.z), layerUuid);
                TnMessage.info("开始布置设备...")
            });
        })
    }

    return (
        <div className="databox-container">
            <SideBarTool onAddBtnClick={onAddClick}
                // onEditClick={onEditClick}
                activeBtnList={[SideBarBtnType.ADD, SideBarBtnType.DELETE, SideBarBtnType.SELECT, SideBarBtnType.UN_SELECT]}
                onDeleteBtnClick={onDeleteClick}
                onSelectBtnClick={() => setMuitiple(true)}
                onUnSelectBtnClick={() => setMuitiple(false)}
            />


            <div className="main-content">
                <div className="panel-title">{getDataBoxTypeName(props.dataBoxType)}</div>
                <div className="table-area">
                    <Table
                        rowKey="id"
                        pagination={false}
                        dataSource={dataBoxes}
                        className='tn-monix-table'
                        rowClassName={row => classnames({
                            "monix-row-select": activeRow?.id === row.id
                        })}
                        bordered={false}
                        onRow={row => {
                            return {
                                onClick: () => setActiveRow(row),
                                onMouseEnter: () => setHoverRow(row),
                                onMouseLeave: () => setHoverRow(null),
                            }
                        }}
                        sticky
                        loading={loading}
                    >
                        <Table.Column dataIndex="name" title="名称" width='33%' ellipsis
                            render={(value, row: GlobalDataBox) => {
                                return (
                                    <>
                                        <Tooltip title={value} placement="bottom">
                                            <div className='multi-cell'>
                                                <div className="multi-icon" onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    let idx = selectedRows?.findIndex(item => item.id === row.id);
                                                    if (idx === -1) {
                                                        setSelectedRows([...selectedRows, row]);
                                                    } else {
                                                        selectedRows.splice(idx, 1);
                                                        setSelectedRows([...selectedRows]);
                                                    }
                                                }}>
                                                    {muitiple && !selectedRows?.some(item => item?.id === row?.id) && <CheckSvg />}
                                                    {muitiple && selectedRows?.some(item => item?.id === row?.id) && <CheckedSvg />}
                                                </div>
                                                <div className="multi-text">{value}</div>
                                            </div>
                                        </Tooltip>
                                    </>
                                )
                            }}
                        />
                        <Table.Column dataIndex="marking" title="型号" width='34%' ellipsis align="center"
                            render={(value) => {
                                return (
                                    <Tooltip title={value} placement="bottom">
                                        <div className='cell'>{value}</div>
                                    </Tooltip>
                                )
                            }}
                        />
                        <Table.Column dataIndex="channelCount" title="通道数" width='33%' ellipsis align="right"
                            render={(value, row: GlobalDataBox) => {
                                if (!!hoverRow && hoverRow?.id === row?.id && !placeRow) {
                                    return (
                                        <div className="place-button" onClick={() => onPlaceClick(row)}>
                                            <div className="place-icon"><PlaceSvg /></div>
                                            <div className="place-text">布置</div>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <Tooltip title={value} placement="bottom">
                                            <div className='cell'>{value}</div>
                                        </Tooltip>
                                    )
                                }

                            }}
                        />
                    </Table>
                </div>
            </div>

            {showAddModal && <LinkGlobalDataBoxModal dataBoxType={props.dataBoxType} visible={showAddModal} setVisible={setShowAddModal}
                onFinish={onAddFinish} loading={addLoading} filterItems={dataBoxes} />}
            {/* {showAddModal && <AddDataBoxModal dataBoxType={props.dataBoxType} visible={showAddModal} setVisible={setShowAddModal} onFinish={onAddFinish} loading={addLoading} />} */}
            {/* {showEditModal && <EditDataBoxModal dataBox={activeRow} visible={showEditModal} setVisible={setShowEditModal} onFinish={onEditFinish} loading={editLoading} />} */}
        </div>
    )
}